export default "__VITE_ASSET__c51ff1a7__"